export enum _VI_FEATURE{
    autoClassifier='auto_classification',
    vis='vis_regular'
}
